import { render, staticRenderFns } from "./IconCaretDown.vue?vue&type=template&id=74bb5ef8&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IconCaretDown.vue"
export default component.exports